<template>
    <section class="">
        <!-- Loading -->
        <loading />

        <div class="module-content">
            <div class="content settings-content">
                <div class="icon-text-wrapper mb-tablet-only">
                    <p
                        @click="showSidebarMenu()"
                        role="button"
                        class="button-body"
                    >
                        Perfil
                    </p>
                </div>

                <h1 class="title-content heading-4">Definições</h1>

                <form
                    @submit.prevent="sendData()"
                    action=""
                    class=""
                    autocomplete="on"
                    method="put"
                    aria-describedby="Professional Data Update"
                >
                    <fieldset>
                        <legend class="heading-6">Perfil</legend>

                        <div class="add-profile-pic">
                            <div class="baseimage_preview">
                                <div
                                    class="element-image-preview"
                                    id="element-image-preview"
                                    :style="`background:url('${imgdefaultaccount}') no-repeat center;`"
                                >
                                    <label
                                        for="professional_img_perfil"
                                        class="form-label btnplus d-flex flex-column align-items-center justify-content-center"
                                        ><img
                                            :src="`${imgdefaultpath}/camera.svg`"
                                            alt="add picture"
                                    /></label>
                                </div>
                            </div>

                            <input
                                @change="
                                    multipleFileData(
                                        $event,
                                        'professional_img_perfil'
                                    )
                                "
                                class="form-control input-file-account"
                                name="files"
                                type="file"
                                id="professional_img_perfil"
                                accept="image/*"
                                ref="professional_img_perfil"
                                data-filealt="professional_img_perfil"
                            />
                        </div>

                        <div class="settings-group-wrapper">
                            <div class="input-label-wrapper">
                                <label for="name" class="form-label"
                                    >Nome *</label
                                >
                                <input
                                    @focusin="inputValidation('name', name)"
                                    @focusout="inputValidation('name', name)"
                                    type="text"
                                    class="form-control"
                                    id="name"
                                    placeholder=""
                                    v-model="name"
                                    maxlength="300"
                                />
                            </div>

                            <!-- email -->
                            <div class="input-label-wrapper">
                                <label for="email" class="form-label"
                                    >Email *</label
                                >
                                <template v-if="!emailverifiedisnull">
                                    <input
                                        @focusin="
                                            inputValidation('email', email)
                                        "
                                        @focusout="
                                            inputValidation('email', email)
                                        "
                                        type="email"
                                        class="form-control"
                                        id="email"
                                        placeholder=""
                                        v-model="email"
                                        maxlength="300"
                                    />
                                </template>
                                <template v-else>
                                    <div
                                        class="confirm-email-container settings-verified-email"
                                    >
                                        <div id="email-container">
                                            <div class="edit-email-setting">
                                                <small
                                                    >O email
                                                    <strong>{{ email }}</strong>
                                                    ainda não foi
                                                    confirmado</small
                                                >

                                                <button
                                                    @click="
                                                        showModal(
                                                            'updatemailmodal'
                                                        )
                                                    "
                                                    type="button"
                                                    class="btn btn-secondary"
                                                    aria-describedby="Update Email"
                                                >
                                                    Editar
                                                </button>
                                            </div>

                                            <button
                                                @click="checkEmail()"
                                                type="button"
                                                class="btn btn-primary w-100"
                                                :disabled="disabledconfirmmail"
                                            >
                                                Enviar email de confirmação
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <div class="input-label-wrapper">
                                <label for="contact" class="form-label"
                                    >Telemóvel *</label
                                >
                                <input
                                    @focusin="
                                        inputValidation('contact', contact)
                                    "
                                    @focusout="
                                        inputValidation('contact', contact)
                                    "
                                    type="text"
                                    class="form-control"
                                    id="contact"
                                    placeholder=""
                                    v-model="contact"
                                    maxlength="9"
                                />
                            </div>

                            <div class="input-label-wrapper">
                                <label for="address" class="form-label"
                                    >Morada *</label
                                >
                                <input
                                    @focusin="
                                        inputValidation('address', address)
                                    "
                                    @focusout="
                                        inputValidation('address', address)
                                    "
                                    type="text"
                                    class="form-control"
                                    id="address"
                                    placeholder=""
                                    v-model="address"
                                    maxlength="400"
                                />
                            </div>

                            <div class="input-label-wrapper double-input-row">
                                <div class="flex-1">
                                    <label for="postalcode" class="form-label"
                                        >Código Postal *</label
                                    >
                                    <input
                                        @focusin="
                                            inputValidation(
                                                'postalcode',
                                                postalcode
                                            )
                                        "
                                        @focusout="
                                            inputValidation(
                                                'postalcode',
                                                postalcode
                                            )
                                        "
                                        type="text"
                                        class="form-control"
                                        id="postalcode"
                                        v-model="postalcode"
                                        maxlength="8"
                                    />
                                </div>
                                <div class="flex-1">
                                    <label for="city" class="form-label"
                                        >Cidade *</label
                                    >
                                    <input
                                        @focusin="inputValidation('city', city)"
                                        @focusout="
                                            inputValidation('city', city)
                                        "
                                        type="text"
                                        class="form-control"
                                        id="city"
                                        v-model="city"
                                        maxlength="100"
                                    />
                                </div>
                            </div>

                            <div class="input-label-wrapper">
                                <label for="nif" class="form-label"
                                    >NIF *</label
                                >
                                <input
                                    @focusin="inputValidation('nif', nif)"
                                    @focusout="inputValidation('nif', nif)"
                                    type="text"
                                    class="form-control"
                                    id="nif"
                                    placeholder=""
                                    maxlength="9"
                                    v-model.number="nif"
                                />
                            </div>

                            <div class="input-label-wrapper">
                                <div class="form-check">
                                    <input
                                        @click="billingAddressIndicate()"
                                        class="form-check-input"
                                        type="checkbox"
                                        id="gridCheck"
                                        :checked="billingAddress"
                                    />
                                    <label
                                        class="form-check-label"
                                        for="gridCheck"
                                    >
                                        Utilizar estes dados para faturação
                                    </label>
                                </div>
                            </div>
                        </div>
                        <template v-if="!billingAddress">
                            <fieldset class="">
                                <legend>Morada de Faturação</legend>

                                <div class="input-label-wrapper">
                                    <label
                                        for="address_billing"
                                        class="form-label"
                                        >Morada *</label
                                    >
                                    <input
                                        @focusin="
                                            inputValidation(
                                                'address_billing',
                                                address_billing
                                            )
                                        "
                                        @focusout="
                                            inputValidation(
                                                'address_billing',
                                                address_billing
                                            )
                                        "
                                        type="text"
                                        class="form-control"
                                        id="address_billing"
                                        placeholder=""
                                        v-model="address_billing"
                                        maxlength="400"
                                    />
                                </div>
                                <div
                                    class="input-label-wrapper double-input-row"
                                >
                                    <div class="flex-1">
                                        <label
                                            for="postalcode_billing"
                                            class="form-label"
                                            >Código Postal *</label
                                        >
                                        <input
                                            @focusin="
                                                inputValidation(
                                                    'postalcode_billing',
                                                    postalcode_billing
                                                )
                                            "
                                            @focusout="
                                                inputValidation(
                                                    'postalcode_billing',
                                                    postalcode_billing
                                                )
                                            "
                                            type="text"
                                            class="form-control"
                                            id="postalcode_billing"
                                            v-model="postalcode_billing"
                                            maxlength="9"
                                        />
                                    </div>
                                    <div class="flex-1">
                                        <label
                                            for="city_billing"
                                            class="form-label"
                                            >Cidade *</label
                                        >
                                        <input
                                            @focusin="
                                                inputValidation(
                                                    'city_billing',
                                                    city_billing
                                                )
                                            "
                                            @focusout="
                                                inputValidation(
                                                    'city_billing',
                                                    city_billing
                                                )
                                            "
                                            type="text"
                                            class="form-control"
                                            id="city_billing"
                                            v-model="city_billing"
                                            maxlength="100"
                                        />
                                    </div>
                                </div>
                            </fieldset>
                        </template>
                    </fieldset>

                    <fieldset class="change-password-setting">
                        <legend>Password e segurança</legend>

                        <div class="item-wrapper">
                            <label for="password" class="form-label"
                                >Palavra passe atual</label
                            >

                            <div class="input-wrapper">
                                <input
                                    v-model="password"
                                    type="password"
                                    class="form-control"
                                    id="password"
                                    @focusin="
                                        inputValidation('password', password)
                                    "
                                    @focusout="
                                        inputValidation('password', password)
                                    "
                                    maxlength="50"
                                    ref="password"
                                />
                                <span
                                    @click="
                                        showHidePass($refs.password, $event)
                                    "
                                    data-show="true"
                                    class="showpass toggle-password"
                                ></span>
                            </div>
                        </div>

                        <div class="item-wrapper">
                            <div class="d-flex flex-column">
                                <div
                                    class="d-flex flex-row justify-content-between"
                                >
                                    <label for="password" class="form-label"
                                        >Nova palavra-passe</label
                                    >
                                </div>
                            </div>
                            <div class="input-wrapper">
                                <input
                                    v-model="newpassword"
                                    type="password"
                                    class="form-control"
                                    id="newpassword"
                                    @keyup="
                                        checkPasswordStructure(
                                            newpassword,
                                            'check-password',
                                            $event
                                        )
                                    "
                                    @focusin="
                                        inputValidation(
                                            'newpassword',
                                            newpassword
                                        ),
                                            showCheckPasswordContainer(
                                                'check-password'
                                            )
                                    "
                                    @focusout="
                                        inputValidation(
                                            'newpassword',
                                            newpassword
                                        ),
                                            hideCheckPasswordContainer(
                                                'check-password'
                                            )
                                    "
                                    maxlength="50"
                                    ref="newpassword"
                                />

                                <span
                                    @click="
                                        showHidePass($refs.newpassword, $event)
                                    "
                                    data-show="true"
                                    class="showpass toggle-password"
                                ></span>

                                <!-- Confirm Passsword Container -->
                                <confirm-container />
                            </div>
                        </div>

                        <div class="item-wrapper">
                            <div class="d-flex flex-column">
                                <div
                                    class="d-flex flex-row justify-content-between"
                                >
                                    <label for="password" class="form-label"
                                        >Confirmar palavra-passe</label
                                    >
                                </div>
                            </div>

                            <div class="input-wrapper">
                                <input
                                    v-model="confirmpassword"
                                    type="password"
                                    class="form-control"
                                    id="confirmpassword"
                                    @focusin="
                                        inputValidation(
                                            'confirmpassword',
                                            confirmpassword
                                        )
                                    "
                                    @focusout="
                                        inputValidation(
                                            'confirmpassword',
                                            confirmpassword
                                        )
                                    "
                                    maxlength="50"
                                    ref="confirmpassword"
                                />

                                <span
                                    @click="
                                        showHidePass(
                                            $refs.confirmpassword,
                                            $event
                                        )
                                    "
                                    data-show="true"
                                    class="showpass toggle-password"
                                ></span>
                            </div>

                            <p class="caption-md color-text-body password-note">
                                *{{ passwordindicate }}
                            </p>
                        </div>
                    </fieldset>

                    <div class="btn-wrapper">
                        <button
                            type="submit"
                            class="btn btn-primary w-100"
                            :disabled="disabled"
                        >
                            Confirmar Alterações
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <!-- Login Form -->
        <modal title="Editar Email" classname="updatemailmodal">
            <template #modalcontent>
                <div class="d-flex flex-column formcontent">
                    <div class="login-form-wrapper">
                        <h2>Editar email</h2>

                        <div class="item-wrapper">
                            <label for="editemail" class="form-label"
                                >Email *</label
                            >
                            <input
                                @focusin="
                                    inputValidation('editemail', editemail)
                                "
                                @focusout="
                                    inputValidation('editemail', editemail)
                                "
                                type="email"
                                class="form-control"
                                id="editemail"
                                placeholder=""
                                v-model="editemail"
                                maxlength="300"
                            />
                        </div>

                        <div class="item-wrapper">
                            <div class="d-flex flex-column">
                                <label for="password_email" class="form-label"
                                    >Palavra passe *</label
                                >

                                <div class="input-wrapper">
                                    <input
                                        v-model="password_email"
                                        type="password"
                                        class="form-control"
                                        id="password_email"
                                        @focusin="
                                            inputValidation(
                                                'password_email',
                                                password_email
                                            )
                                        "
                                        @focusout="
                                            inputValidation(
                                                'password_email',
                                                password_email
                                            )
                                        "
                                        maxlength="50"
                                        ref="password_email"
                                    />
                                    <span
                                        @click="
                                            showHidePass(
                                                $refs.password_email,
                                                $event
                                            )
                                        "
                                        data-show="true"
                                        class="showpass toggle-password caption-lg"
                                        role="button"
                                    ></span>
                                </div>
                            </div>
                        </div>

                        <div class="btn-item-wrapper">
                            <button
                                type="button"
                                class="btn btn-primary btn-filled-blue button-body"
                                aria-describedby="Confirm Email Update"
                                :disabled="disablededitmail"
                                @click="editEmail()"
                            >
                                Confirmar
                            </button>

                            <button
                                type="button"
                                class="btn btn-cancel button-body"
                                aria-describedby="Confirm Email Update"
                                @click="hideModal('updatemailmodal')"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </modal>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </section>
</template>
<script>
import fetchData from "./../../../../fetchData.js";
import inputValidation from "./../../../../validationInputs.js";
import Loading from "./../../../elements/LoadingElement.vue";
import ListMessage from "./../../../elements/ListMessageElement.vue";
import responseMessage from "./../../../../responseMessage";
import defaultWebsite from "./../../../../defaultWebsiteScript.js";
import Modal from "./../../../elements/ModalElement.vue";
import ConfirmPassContainer from "./../../../elements/confirmPasswordContainer.vue";

//Set Use Strict
("use strict");

export default {
    name: "Settings",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        imgdefaultaccount: {
            type: String,
            required: true,
        },
        checkemailurl: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        moduledata: {
            type: String,
            required: true,
        },
        emailverifiedisnull: {
            type: String,
            required: true,
        },
        editemailurl: {
            type: String,
            required: true,
        },
        passwordindicate: {
            type: String,
            required: true,
        },
        imgdefaultpath: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            email: "",
            password: "",
            newpassword: "",
            confirmpassword: "",
            disabled: true,
            disabledconfirmmail: false,
            activeclass: "d-flex",
            inputNotIsValid: true,
            name: "",
            contact: "",
            address: "",
            postalcode: "",
            city: "",
            nif: "",
            formData: {
                data: {
                    file: {},
                },
                billing_address: {},
                security: {},
            },
            billingAddress: true,
            address_billing: "",
            postalcode_billing: "",
            city_billing: "",
            alertmegabyte: 1024 * 1000 * 1.2,
            filedataformlist: [],
            filedataformitemlist: {},
            filewidthheightlist: [],
            filedataformlistMediaData: [],
            moduleData: {},
            password_email: "",
            editemail: "",
            disablededitmail: true,
            checkPasswordData: [],
            checkPasswordTypes: [],
        };
    },
    created() {
        //Decode Data
        this.moduleData = JSON.parse(this.moduledata);

        //Set Confirm Passwords Patterns
        this.checkPasswordTypes = inputValidation.confirmPasswordPatterns();
    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });

        //Set Update Values
        this.setUpdateValues(this.moduleData);
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        checkPasswordStructure(password, elementbase, element) {
            //Clean Data
            if (element.key === "Backspace") {
                this.checkPasswordData = [];

                //Remove all Icons
                if (document.querySelector(".check-password-icon")) {
                    [
                        ...document.querySelectorAll(".check-password-icon"),
                    ].forEach((value) => value.remove());
                }
            }

            if (
                (password !== "" && element.key !== "Backspace") ||
                element.key !== "Shift" ||
                element.key !== "CapsLock"
            ) {
                //Execute Confirm Password
                this.checkPasswordData = inputValidation.confirmPassword(
                    password,
                    elementbase
                );

                if (this.checkPasswordData.length > 0) {
                    //Set Confirm Password Element
                    inputValidation.confirmPasswordAddIcon(
                        elementbase,
                        this.checkPasswordData
                    );

                    //Disable Button Conditional
                    this.disabled = true;
                }
            }
        },
        showCheckPasswordContainer(elementbase) {
            if (this.checkPasswordData.length > 0) {
                //Set Confirm Password Element
                inputValidation.confirmPasswordAddIcon(
                    elementbase,
                    this.checkPasswordData
                );

                //Disable Button Conditional
                this.disabled = true;
            }

            //Show Base Element
            document
                .getElementById(`${elementbase}`)
                .classList.remove("d-none");
            document.getElementById(`${elementbase}`).classList.add("d-flex");
        },
        hideCheckPasswordContainer(elementbase) {
            //Remove all Icons
            if (document.querySelector(".check-password-icon")) {
                [...document.querySelectorAll(".check-password-icon")].forEach(
                    (value) => value.remove()
                );
            }

            //Hide Base Element
            document
                .getElementById(`${elementbase}`)
                .classList.remove("d-flex");
            document.getElementById(`${elementbase}`).classList.add("d-none");
        },
        showModal(classname) {
            //Disabled Button
            this.disabled = true;

            //Show Modal
            $(`.${classname}`).modal("show");
        },
        hideModal(classname) {
            //Hide Modal
            $(`.${classname}`).modal("hide");
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        showHidePass(inputelement, element) {
            //Execute Default Show|Hide Password method
            defaultWebsite.showPassword(inputelement, element.target);
        },
        setUpdateValues(moduledata) {
            //Set Values
            this.name = moduledata.name;
            this.email = moduledata.email;
            this.contact = moduledata.contact.contact;
            this.address = moduledata.contact.default_address.address;
            this.postalcode = moduledata.contact.default_address.postalcode;
            this.city = moduledata.contact.default_address.city;
            this.nif = moduledata.nif;
            this.address_billing = moduledata.contact.billing_address.address;
            this.postalcode_billing =
                moduledata.contact.billing_address.postalcode;
            this.city_billing = moduledata.contact.billing_address.city;

            //Set Image
            document.getElementById(
                "element-image-preview"
            ).style.background = `url('${moduledata.image}') no-repeat center`;
        },
        inputValidation(inputid, inputvalue) {
            //Check Value
            if (inputvalue === "") {
                //Disable button
                this.disabled = true;
                this.disablededitmail = true;

                return;
            }

            //Check Inputs
            switch (inputid) {
                //Name
                case "name":
                    this.disabled = inputValidation.validNameCases(
                        1,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Address
                case "address":
                case "address_billing":
                    this.disabled = inputValidation.validNameCases(
                        4,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Email
                case "email":
                case "editemail":
                    switch (inputid) {
                        case "editemail":
                            this.disablededitmail =
                                inputValidation.validNameCases(7, inputvalue)
                                    ? false
                                    : true;
                            break;

                        default:
                            this.disabled = inputValidation.validNameCases(
                                7,
                                inputvalue
                            )
                                ? false
                                : true;
                            break;
                    }

                    break;

                //Contact
                case "contact":
                    this.disabled = inputValidation.validNameCases(
                        2,
                        inputvalue
                    )
                        ? false
                        : true;

                    //Check Length
                    if (inputvalue.length <= 8) {
                        this.disabled = true;
                    }

                    break;

                //Postalcode
                case "postalcode":
                case "postalcode_billing":
                    this.disabled = inputValidation.validNameCases(
                        2,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Password
                case "password":
                case "newpassword":
                case "confirmpassword":
                case "password_email":
                    switch (inputid) {
                        case "password_email":
                            this.disablededitmail =
                                inputValidation.validNameCases(11, inputvalue)
                                    ? false
                                    : true;
                            break;

                        default:
                            this.disabled = inputValidation.validNameCases(
                                11,
                                inputvalue
                            )
                                ? false
                                : true;
                            break;
                    }

                    break;

                //City
                case "city":
                case "city_billing":
                    this.disabled = inputValidation.validNameCases(
                        1,
                        inputvalue
                    )
                        ? false
                        : true;

                    break;

                //Nif
                case "nif":
           
                    //Check Length
                    if (inputvalue.toString().length === 9) {
                        this.disabled = inputValidation.validNameCases(
                            12,
                            inputvalue
                        )
                            ? false
                            : true;

                        //Check Nif structure
                        if(!this.disabled){

                            this.disabled = inputValidation.isValidNif(inputvalue);
                           
                        }

                    } else {
                        this.disabled = true;
                    }

                    break;
            }

            //Only for Disabled Email
            if (
                this.disablededitmail &&
                ["password_email", "editemail"].includes(inputid)
            ) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );

                return;
            }

            //Set Conditional for input is valid
            this.inputNotIsValid = this.disabled;

            //Show Error Message
            if (
                this.disabled &&
                !["password_email", "editemail"].includes(inputid)
            ) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        billingAddressIndicate() {
            //Set new Conditional
            this.billingAddress = this.billingAddress ? false : true;
        },
        createImage(inputid, height = "75", width = "150") {
            //Create LI Element
            return htmlElements.createElement("img", {
                class: `preview_${inputid} my-3`,
                id: `preview_${inputid}`,
                src: "",
                height: height,
                width: width,
                alt: "preview",
                style: "object-fit: scale-down;",
            });
        },
        multipleFileData(element, inputid) {
            //Set Disabled
            element.target.setAttribute("disabled", true);

            //FileData Item Object Clean Variable
            this.filedataformitemlist = {};

            //Get Data from File
            let filedata = element.target.files;

            //Remove Old Preview Image
            document.getElementById("element-image-preview").style = "";

            //Create Image Element
            //let img = this.createImage(inputid);

            //Get Data from Multiple File
            [...filedata].forEach((value, index) => {
                //Check fileSize
                if (value.size >= Math.abs(this.alertmegabyte)) {
                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        "danger",
                        "Please upload a smaller file up to 1MG",
                        this.activeclass
                    );

                    //Enabled Input
                    element.target.removeAttribute("disabled");

                    //Disabled Submit button
                    //this.disabled = true;

                    return;
                }

                //Check type of the file
                if (!value.type.includes("image")) {
                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        "danger",
                        "Please only send image type file",
                        this.activeclass
                    );

                    //Enabled Input
                    element.target.removeAttribute("disabled");

                    return;
                }

                //Structure File Data Object
                this.filedataformitemlist = {
                    fileindex: index,
                    filename: value.name.trim(),
                    filedata: {},
                };

                //Get Width and Height from Image
                let reader = new FileReader();
                reader.readAsDataURL(value);
                reader.onload = (e) => {
                    const src = e.target.result;

                    const img = new Image();

                    img.onload = () => {
                        //Set FileDimension
                        let filedimension = {
                            width: img.width,
                            height: img.height,
                        };

                        //Set File width and height
                        this.filewidthheightlist.push(filedimension);

                        return this.filewidthheightlist;
                    };

                    img.onerror = (error) => {
                        throw new Error(error);
                    };

                    img.src = src;
                };

                //Create Event Listenner
                reader.addEventListener(
                    "load",
                    () => {
                        // convert image file to base64 string
                        //img.src = reader.result;
                        //Set Preview Image Content
                        document.getElementById(
                            "element-image-preview"
                        ).style.background = `url('${reader.result}') no-repeat center`;
                    },
                    false
                );

                //Get base64 Promise
                let file64Promise = fetchData.toBase64(value);

                //Get Data from Promise
                file64Promise
                    .then((val64) => {
                        //Check File Alt
                        //let filealtname = element.target.getAttribute('data-filealt') + '_' + value.name.toLocaleLowerCase();

                        //Structure File Data Object
                        this.filedataformitemlist.filedata = {
                            type: value.type.replace("image/", ""),
                            filealt: element.target
                                .getAttribute("data-filealt")
                                .trim(),
                            file64: val64,
                            filealldimensions: this.filewidthheightlist[index]
                                ? this.filewidthheightlist[index]
                                : null,
                            filename: value.name.trim(),
                        };

                        //Check Old Image Data and remove old image data
                        //this.oldImageUpdateRoutine(element.target.getAttribute('data-storeid'), this.filedataformitemlist.filedata);

                        //Push Data
                        if (this.filedataformlist.length === 0) {
                            this.filedataformlist.push(
                                this.filedataformitemlist
                            );
                        } else {
                            //Clean Old Image Data
                            this.filedataformlist = [];

                            //Push New Data Image
                            this.filedataformlist.push(
                                this.filedataformitemlist
                            );
                        }

                        //Enabled Button
                        this.disabled = false;

                        //Remove Disabled Attribute
                        element.target.removeAttribute("disabled");

                        //Send Data for Storage File
                        return this.filedataformlist;
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            });
        },
        oldImageUpdateRoutine(storeid, newimgdata) {
            //Check Old Image Data
            if (
                this.routine === "PUT" &&
                this.filedataformlistMediaData.length > 0
            ) {
                //Index old image
                //let indexOldImg = null;

                this.filedataformlistMediaData.forEach(
                    (valoldimg, indexoldimg) => {
                        if (valoldimg.media.store_id === parseInt(storeid)) {
                            //indexOldImg = indexoldimg;

                            //Update FileData
                            valoldimg.filedata.newimg = newimgdata;
                        }
                    }
                );

                /* if(indexOldImg !== null){

                    //Remove old data from FileData
                    this.filedataformlistMediaData.splice(indexOldImg, 1);

                } */
            }
        },
        checkRequiredInputs(requiredInputsList) {
            //Required
            let required = true;

            Object.keys(this.$data).forEach((valkey) => {
                const dataKey = Object.getOwnPropertyDescriptor(
                    this.$data,
                    valkey
                );

                //Check Empty Inputs
                if (
                    requiredInputsList.includes(valkey) &&
                    dataKey.value === ""
                ) {
                    required = false;
                }
            });

            return required;
        },
        defaultRequestMethod(
            btnelement,
            requesturl,
            dataform,
            routine,
            method = "PATCH"
        ) {
            //Disabled Button
            btnelement = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Send Data
            let response = fetchData.structureTosendData(
                requesturl,
                dataform,
                this.csrftolken,
                method
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Enabled Button
                    btnelement = false;

                    //Routine
                    switch (routine) {
                        case "editmail":
                            //Set new email
                            this.email = this.editemail;

                            //Att SideBar
                            document.getElementById(
                                "professionalmail"
                            ).textContent = this.editemail;

                            this.hideModal("updatemailmodal");

                            break;
                    }

                    //Add active Class
                    this.$refs.responsebasemessage.classList.add(
                        this.activeclass
                    );
                    this.$refs.responsebasemessage.classList.add(
                        value.classname
                    );

                    //Element for append
                    let li = responseMessage.messageStructure(
                        value.message,
                        value.classname
                    );

                    //Append Element
                    $(li).appendTo(this.$refs.responsebasemessage.children);

                    //Remove Message
                    responseMessage.removeResponseMessages(10000);

                    return;
                })
                .catch((error) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Enabled Button
                    btnelement = false;

                    throw new Error(error);
                });
        },
        checkEmail() {
            //Default Response
            return this.defaultRequestMethod(
                this.disabledconfirmmail,
                this.checkemailurl,
                { email: this.email.trim() },
                "confirmmail"
            );
        },
        editEmail() {
            //Check by empty values
            if (this.editemail === "" || this.password_email === "") {
                //Enabled Button
                this.disabldisablededitmailed = false;

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Todos os campos com * são de preenchimento obrigatório",
                    this.activeclass
                );

                return;
            }

            //Default Response
            return this.defaultRequestMethod(
                this.disabldisablededitmailed,
                this.editemailurl,
                {
                    email: this.editemail.trim(),
                    password: this.password_email.trim(),
                },
                "editmail"
            );
        },
        sendData() {
            //Disabled Button
            this.disabled = true;

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Required Inputs
            let requiredInputsList = [
                "name",
                "contact",
                "address",
                "postalcode",
                "city",
                "nif",
            ];

            //Required
            let required = this.checkRequiredInputs(requiredInputsList);

            //Check Required
            if (!required) {
                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                //Enabled Button
                this.disabled = false;

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Todos os campos com * são de preenchimento obrigatório",
                    this.activeclass
                );

                return;
            }

            //===> Develop one more security layer for NIF
            if (
                this.nif.length < 9 ||
                this.postalcode.length < 7 ||
                !Number.isInteger(parseInt(this.nif)) ||
                !Number.isInteger(parseInt(this.postalcode))
            ) {
                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                //Enabled Button
                this.disabled = false;

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "O valor informado é inválido",
                    this.activeclass
                );

                return;
            }

            //Get Form Data
            this.formData.data.id = this.moduleData.id;
            this.formData.data.name = this.name.trim();
            this.formData.data.email = this.email.trim();
            this.formData.data.contact = this.contact;
            this.formData.data.nif = this.nif;
            this.formData.data.address = this.address.trim();
            this.formData.data.postalcode = this.postalcode.trim();
            this.formData.data.city = this.city.trim();

            //Set BillingAddress
            if (this.billingAddress) {
                this.formData.billing_address.address =
                    this.formData.data.address;
                this.formData.billing_address.postalcode =
                    this.formData.data.postalcode;
                this.formData.billing_address.city = this.formData.data.city;
            } else {
                //Required Inputs
                requiredInputsList = [
                    "address_billing",
                    "postalcode_billing",
                    "city_billing",
                ];

                //Required
                required = this.checkRequiredInputs(requiredInputsList);

                //Check Required
                if (!required) {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Enabled Button
                    this.disabled = false;

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        "danger",
                        "Todos os campos com * são de preenchimento obrigatório",
                        this.activeclass
                    );

                    return;
                }

                //===> Develop one more security layer for NIF
                if (
                    this.postalcode_billing.length < 7 ||
                    !Number.isInteger(parseInt(this.postalcode_billing))
                ) {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Enabled Button
                    this.disabled = false;

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        "danger",
                        "O valor informado é inválido",
                        this.activeclass
                    );

                    return;
                }

                this.formData.billing_address.address =
                    this.address_billing.trim();
                this.formData.billing_address.postalcode =
                    this.postalcode_billing.trim();
                this.formData.billing_address.city = this.city_billing.trim();
            }

            //Check Account Image
            if (this.filedataformlist.length > 0) {
                Object.assign(
                    this.formData.data.file,
                    this.filedataformlist[0]
                );
            }

            //Set Security Data
            this.formData.security.oldpassword =
                this.password !== "" ? this.password.trim() : null;
            this.formData.security.newpassword =
                this.newpassword !== "" ? this.newpassword.trim() : null;

            //Check Security Data
            if (
                (this.formData.security.oldpassword !== null &&
                    this.formData.security.newpassword === null) ||
                (this.formData.security.newpassword !== null &&
                    this.formData.security.oldpassword === null)
            ) {
                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                //Enabled Button
                this.disabled = false;

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "É necessário informar o valor para o campo em Password e Segurança",
                    this.activeclass
                );

                return;
            }

            //Check Password and Confirm Password
            if (
                this.newpassword !== "" &&
                this.confirmpassword !== "" &&
                this.newpassword !== this.confirmpassword
            ) {
                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                //Enabled Button
                this.disabled = false;

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "O password e o confirm password não são equivalentes",
                    this.activeclass
                );

                return;
            }

            //Send Data
            let response = fetchData.structureTosendData(
                this.routineurl,
                this.formData,
                this.csrftolken,
                "PUT"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Enabled Button
                    this.disabled = false;

                    //Add active Class
                    this.$refs.responsebasemessage.classList.add(
                        this.activeclass
                    );
                    this.$refs.responsebasemessage.classList.add(
                        value.classname
                    );

                    //Check Type
                    if (Array.isArray(value.message)) {
                        value.message.forEach((valmsg) => {
                            //Element for append
                            let li = responseMessage.messageStructure(
                                valmsg,
                                value.classname
                            );

                            //Append Element
                            $(li).appendTo(
                                this.$refs.responsebasemessage.children
                            );
                        });

                        return;
                    }

                    //Element for append
                    let li = responseMessage.messageStructure(
                        value.message,
                        value.classname
                    );

                    //Append Element
                    $(li).appendTo(this.$refs.responsebasemessage.children);

                    //Remove Message
                    responseMessage.removeResponseMessages(10000);

                    //Reload Page
                    if (Object.is(value.classname, "success")) {
                        //Redirect for Admin Route
                        window.location.reload();
                    }

                    return;
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        billingAddressComputed() {
            return this.billingAddress;
        },
        computedFiledataFormList() {
            return this.filedataformlist;
        },
        computedFileFormItemList() {
            return this.filedataformitemlist;
        },
        computedFileWidthHeightList() {
            return this.filewidthheightlist;
        },
    },
    watch: {
        billingAddressComputed() {},
        computedFiledataFormList() {},
        computedFileFormItemList() {},
        computedFileWidthHeightList() {},
    },
    components: {
        loading: Loading,
        listMessage: ListMessage,
        modal: Modal,
        confirmContainer: ConfirmPassContainer,
    },
};
</script>
